export default function isPreAPOrSpringboardSlug(slug) {
    // include all Pre-AP slugs that start with preap, but also Springboard slugs that start with sb/springboard
    return slug.startsWith('preap') || slug.startsWith('sb') || slug.startsWith('springboard');
}



/** WEBPACK FOOTER **
 ** core/client/utils/slug.js
 **/